<template>
  <div
    class="bg-white rounded-lg p-4 md:p-6 c-shadow transition w-full h-full cursor-pointer hover:bg-blue card"
  >
    <img :src="icon" alt="icon" class="w-10 h-10 mb-4" />
    <h3 class="text-lg font-bold font-poppins text-gray-900 mb-2">
      {{ title }}
    </h3>
    <p
      class="text-gray-600 text-sm font-poppins leading-relaxed"
      v-html="description"
    ></p>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  icon: string;
  title: string;
  description: string;
}>();
</script>
<style scoped>
.card,
.card * {
  transition: all 0.5s ease;
}
.card:hover * {
  color: white;
}
.card:hover img {
  filter: brightness(0) invert(1);
}
.c-shadow {
  box-shadow: 0 5px 10px 0 rgba(49, 49, 49, 0.1);
}
</style>
